const html = require('choo/html');
const {
  unselectedAnswerStyle,
  stickToBottom,
  bgCorrectAnswer,
  bgWrongAnswer,
  textCorrectAnswer,
  textWrongAnswer,
  questionTextStyle
} = require('../lib/styles');

module.exports = view;

function view(state, emit) {
  function submitAnswer(questionId, answer) {
    emit('quiz:answer', questionId, answer);
  }

  function nextQuestion() {
    emit('quiz:nextQuestion');
  }

  return html`
    <div>
      ${state.chosenAnswer !== undefined
        ? ''
        : html`
            <section class="${questionTextStyle} pa3">
              ${state.question}
            </section>
          `}
      ${state.chosenAnswer !== undefined
        ? html`
            <div class="pa3">
              <div
                class="pa3 f2 mw6-ns center ${state.correct
                  ? bgCorrectAnswer
                  : bgWrongAnswer}"
              >
                <img
                  src="../assets/${state.correct ? 'check-blue' : 'x-red'}.svg"
                />

                ${state.correct
                  ? html`
                      <span class="${textCorrectAnswer}">Correct</span>
                    `
                  : html`
                      <span class="${textWrongAnswer}">Wrong</span>
                    `}
                ${state.chosenAnswer !== undefined
                  ? html`
                      <div class="f5 f3-ns lh-title pt2">
                        ${state.explanation}
                      </div>
                    `
                  : ''}
              </div>
            </div>
          `
        : html`
            <section class="${stickToBottom}">
              <ul class="list pa0 ma0 flex">
                <li
                  class="${unselectedAnswerStyle} w-50 mr1"
                  onclick="${() => {
                    submitAnswer(state.id, 1);
                  }}"
                >
                  Yes
                </li>
                <li
                  class="${unselectedAnswerStyle} w-50"
                  onclick="${() => {
                    submitAnswer(state.id, 0);
                  }}"
                >
                  No
                </li>
              </ul>
            </section>
          `}
      ${state.chosenAnswer !== undefined
        ? html`
            <section class="${stickToBottom}">
              <button
                class="${unselectedAnswerStyle} w-100"
                onclick="${() => {
                  nextQuestion();
                }}"
              >
                Next
              </button>
            </section>
          `
        : ''}
    </div>
  `;
}
